






































import { Component, Vue, Prop } from "vue-property-decorator";
import { Plan } from "@foxone/api/src/models/hfox";
import { USDT_ASSET } from "hfox/constants";

@Component
class IncomingSchedule extends Vue {
  @Prop() plan!: Plan;

  get meta() {
    const symbol = USDT_ASSET.symbol;
    return {
      symbol,
      time: this.$common.utils.date.formatDate(
        this.plan.next_schedule_at * 1000,
        "YYYY/MM/DD"
      ),
      amount: this.plan.funds,
      amountText: this.plan.funds + " " + symbol
    };
  }
}
export default IncomingSchedule;
